import * as Api from '@ViewModels';
import { ISelectBoxOption } from '../../../../web/components/SelectBox';

export const IndustryOptions: ISelectBoxOption<Api.Industry>[] = [...Api.AllIndustries].map(industry => {
	return {
		title: industry,
		value: industry,
	};
});

export const SystemOfRecordOptions: ISelectBoxOption<Api.SystemOfRecord | string>[] = [
	{ title: 'Select One', value: '' },
	...[...Api.AllSystemsOfRecord].sort().map(systemOfRecord => {
		return {
			title: systemOfRecord,
			value: systemOfRecord,
		};
	}),
];
